export default "/assets/site/images/full_size.png?22e832d55a4d73dbdae1a6ac1a87dfc8";